import { render, staticRenderFns } from "./sxtongji.vue?vue&type=template&id=279971e5&scoped=true"
import script from "./sxtongji.vue?vue&type=script&lang=js"
export * from "./sxtongji.vue?vue&type=script&lang=js"
import style0 from "./sxtongji.vue?vue&type=style&index=0&id=279971e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279971e5",
  null
  
)

export default component.exports